import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/bankguarantee/:id',
    name: 'bankguarantee',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/hello.vue'),
    meta: {
      title: "Bank Guarantee"
    }
  },
  {
    path : '/not-found',
    name : 'not-found',
    component: () => import('../components/Error404.vue'),
    meta: {
      title : "Page Not Found"
    }
  },
  {
    path: '/',
    name: 'home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../components/home.vue'),
    meta: {
      title: ""
    }
  },
  {
    path: '/:catchAll(.*)',
    component: () => import('../components/Error404.vue')
  }
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
